<template>
    <div>
        <div v-if="$route.path=== '/resources-and-tools/ogden-table-viewer'" class="flex-grid p-resources-and-tools__documents">
            <h2>Ogden Table Viewer</h2>
            <div class="p-resources-and-tools__document">
                <select v-model="selectedTable" @change="obtainOgdenTable()">
                    <option :value="ogdenTable" v-for="ogdenTable in ogdenTables">{{ogdenTable.name}} -
                        {{ogdenTable.description}}
                    </option>
                </select>
            </div>
            <ogden-table-viewer v-if="!!tableData && selectedTable" :description="selectedTable.description"
                                :name="selectedTable.name" :tableData="tableData"></ogden-table-viewer>
        </div>



        <div v-if="$route.path=== '/resources-and-tools/at-a-glance-viewer'" @change="atAGlanceViewer()" class="flex-grid p-resources-and-tools__documents">
            <h2>At a Glance Viewer</h2>
            <div class="p-resources-and-tools__document">
                <select v-model="gender">
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                </select>
                Discount
                <select v-model="discount">
                    <option v-for="discount in discounts" :value="discount">{{discount}}%</option>
                </select>
            </div>
            <at-a-glance-viewer v-if="atAGlance.data" :description="gender + ' - ' + discount+'%'"
                                :name="'At A Glance Ogden Viewer'"
                                :tableData="atAGlance.data"></at-a-glance-viewer>
        </div>
    </div>

</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import OgdenTableViewer from 'pages/resources-and-tools/OgdenTables/OgdenTableViewer.vue';
    import AtAGlanceViewer from 'pages/resources-and-tools/OgdenTables/AtAglanceViewer.vue';

    export default {
        created() {
            this.getOgdenList();
        },
        data() {
            return {
                selectedTable: null,
                tableData: null,
                dataHeaders: null,
                discount: 0.00,
                gender: 'male',
                discounts: [
                    -2.00, -1.50, -1.00, -0.75, -0.50, -0.25, 0.00, 0.50, 1.00, 1.50, 2.00, 2.50, 3.00,
                ],
            }
        },
        components: {
            OgdenTableViewer,
            AtAGlanceViewer
        },
        computed: {
            ...mapGetters({
                ogdenTables: 'resources/ogdenTables',
                ogdenTableData: 'resources/ogdenTableData',
                atAGlance: 'resources/atAGlance'
            }),
        },
        methods: {
            ...mapActions({
                getOgdenList: 'resources/loadOgdenTables',
                getOgdenValues: 'resources/obtainOgdenTable',
                getAtAGlance: 'resources/atAGlance'
            }),
            obtainOgdenTable() {
                if(!this.selectedTable) {
                    return;
                }
                this.getOgdenValues(this.selectedTable.value).then(() => {
                    this.tableData = this.ogdenTableData[this.selectedTable.value];
                    this.dataHeaders = Object.keys(this.ogdenTableData[this.selectedTable.value]);
                });
            },
            atAGlanceViewer() {
                this.getAtAGlance({discount: this.discount, gender: this.gender});
            }
        }
    }

</script>


// WEBPACK FOOTER //
// OgdenTable.vue?3668879d